"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanStringTransform = exports.parseBoolean = void 0;
const parseBoolean = (value) => {
    if (typeof value === 'boolean')
        return value;
    if (value === 'true' || value === '1' || value === 1)
        return true;
    return false;
};
exports.parseBoolean = parseBoolean;
// Define the transformation function
const BooleanStringTransform = ({ value }) => {
    if (typeof value === 'boolean')
        return value;
    if (value === 'true' || value === '1' || value === 1)
        return true;
    if (value === 'false' || value === '0' || value === 0)
        return false;
    return value;
};
exports.BooleanStringTransform = BooleanStringTransform;
